export class Photo {
  constructor(data) {
    var self = this;
    self.type = "PhotoXX";

    if (data == undefined) {
      data = {};
    }

    self.photo_uuid = ko.observable(data.photo_uuid);
    self.uploaded_by = ko.observable(data.uploaded_by);
    self.full_path_url = ko.observable(data.full_path_url);
    self.icon_path_url = ko.observable(data.icon_path_url);
    self.preview_path_url = ko.observable(data.preview_path_url);
    self.profile_path_url = ko.observable(data.profile_path_url);
    self.original_path_url = ko.observable(data.original_path_url);

    self.discount_code_ = ko.observable(data.original_path_url);
    self.original_path_url = ko.observable(data.original_path_url);

    self.discount_code_sample_en = ko.observable(data.discount_code_sample_en);
    self.discount_code_sample_de = ko.observable(data.discount_code_sample_de);

    self.thumbnails_processing = ko.observable(data.thumbnails_processing);

    // Image cropping stuff
    self.crop_active = ko.observable(false);
    self.image_process = ko.observable(false);

    self.crop_box = {
      crop_x1: 0,
      crop_y1: 0,
    };

    self.crop_x1 = ko.observable();
    self.crop_y1 = ko.observable();

    self.image_ratio = ko.observable();
    self.image_height;
    self.image_width;
    self.frame_ratio = ko.observable(2);

    self.originX = ko.observable(data.crop_x1 || 0);
    self.originY = ko.observable(data.crop_y1 || 0);

    self.deltaX = ko.observable(0);
    self.deltaY = ko.observable(0);

    self.mouseX;
    self.mouseY;

    self.image_loaded = function (data_vm, _event) {
      //console.log('new image loaded');
      // this is loaded image
      self.image_load_handler = true;

      if (data == undefined || data.crop_x1 == undefined) {
        self.originX(0);
        self.originY(0);
      }
      self.image_ratio(_event.target.width / _event.target.height);

      self.calculate_style_left();
      self.calculate_style_top();
    };

    self.is_processing = ko.pureComputed(function () {
      return (
        self.full_path_url() == undefined ||
        self.icon_path_url() == undefined ||
        self.preview_path_url() == undefined ||
        self.profile_path_url() == undefined
      );
    });

    // Image Cropping Stuff
    //
    self.hitX;
    self.hitY;

    self.onMouseMove = function (data, _event) {
      if (!self.crop_active()) return;

      self.mouseX = _event.clientX;
      self.mouseY = _event.clientY;

      self.moveImage();

      _event.stopPropagation();
    };

    self.onTouchMove = function (data, _event) {
      if (!self.crop_active()) return;

      var touch = _event.originalEvent.touches[0];

      self.mouseX = touch.clientX;
      self.mouseY = touch.clientY;

      self.moveImage();

      _event.stopPropagation();
    };

    self.onMouseStart = function (data, _event) {
      self.crop_active(true);

      self.image_width = _event.target.width;
      self.image_height = _event.target.height;

      self.hitX = _event.clientX;
      self.hitY = _event.clientY;

      _event.stopPropagation();
    };

    self.onTouchStart = function (data, _event) {
      self.crop_active(true);

      self.image_width = _event.target.width;
      self.image_height = _event.target.height;

      var touch = _event.originalEvent.touches[0];

      self.hitX = touch.clientX;
      self.hitY = touch.clientY;

      _event.stopPropagation();
    };

    self.onStop = function (data, _event) {
      self.originX(self.originX() + self.deltaX());
      self.originY(self.originY() + self.deltaY());
      self.deltaX(0);
      self.deltaY(0);
      self.crop_active(false);

      var original_size, crop_width, crop_height, crop_x1, crop_y1;

      original_size = {
        width: self.image_width,
        height: self.image_height,
      };

      crop_x1 = self.originX();
      crop_y1 = self.originY();

      if (self.moveAxis() == "y") {
        crop_width = self.image_width;
        crop_height = self.image_width / self.frame_ratio();
      } else {
        crop_width = self.image_height * self.frame_ratio();
        crop_height = self.image_height;
      }

      var crop_box = {
        photo_uuid: self.photo_uuid(),
        original_size: original_size,
        crop_width: crop_width,
        crop_height: crop_height,
        crop_x1: crop_x1,
        crop_y1: crop_y1,
      };

      if (
        crop_box.crop_x1 != self.crop_box.crop_x1 ||
        crop_box.crop_y1 != self.crop_box.crop_y1
      ) {
        self.crop_photo(crop_box);
      }

      self.crop_box = crop_box;
    };

    self.onDragStart = function () {
      return false;
    };

    self.moveAxis = ko.computed(function () {
      if (self.image_ratio() < self.frame_ratio()) return "y";
      else return "x";
    });

    self.imageRelativeWidth = ko.computed(function () {
      return self.moveAxis() == "x" ? "auto" : "100%";
    });

    self.imageRelativeHeight = ko.computed(function () {
      return self.moveAxis() == "y" ? "auto" : "100%";
    });

    self.style_left = ko.observable(self.originX() + self.deltaX() + "px");
    self.style_top = ko.observable(-(self.originY() + self.deltaY()) + "px");

    self.calculate_style_left = function () {
      self.style_left(self.originX() + self.deltaX() + "px");
    };

    self.calculate_style_top = function () {
      self.style_top(-(self.originY() + self.deltaY()) + "px");
    };

    self.moveImage = function () {
      var deltaX, deltaY;

      if (self.moveAxis() == "x") deltaX = self.hitX - self.mouseX;
      else if (self.moveAxis() == "y") deltaY = self.hitY - self.mouseY;

      var predictedY = self.originY() + deltaY;
      var maxY = self.image_height - self.image_width / self.frame_ratio();

      var predictedX = self.originX() + deltaX;
      var maxX = self.image_width - self.image_height * self.frame_ratio();

      if (predictedY > 0 && predictedY < maxY) self.deltaY(deltaY);
      self.calculate_style_top();

      if (predictedX > 0 && predictedX < maxX) self.deltaX(deltaX);
      self.calculate_style_left();
    };

    self.check_photo = function () {
      return $.ajax({
        url: "/api/photo",
        type: "GET",
        data: {
          photo_uuid: self.photo_uuid(),
        },

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.photo) {
            self.full_path_url(data.photo.full_path_url);
            self.icon_path_url(data.photo.icon_path_url);
            self.preview_path_url(data.photo.preview_path_url);
            self.profile_path_url(data.photo.profile_path_url);
            self.original_path_url(data.photo.original_path_url);
            self.thumbnails_processing(data.photo.thumbnails_processing);
          }
        },
        error: function (data) {},
        complete: function () {},
      });
    };

    self.crop_photo = function (data) {
      return $.ajax({
        url: "/api/photo/crop",
        type: "POST",
        data: ko.toJSON(data),
        contentType: "application/json; charset=utf-8",
        processData: false,

        success: function (data) {
          console.log("photo cropped updated");
        },

        error: function (data) {
          self.error(data.statusText);
        },
      });
    };
  }
}
